import DirhamSvg from '@assets/images/svg/dhiram.svg';
import React from 'react';

export interface DirhamIconProps {
    size?: number;
    width?: number;
    height?: number;
    color?: string;
}

export function DirhamIcon({
    size = 24,
    width,
    height,
    color = '#333333',
}: Readonly<DirhamIconProps>) {
    return (
        <DirhamSvg
            width={width ?? size}
            height={height ?? size}
            color={color}
        />
    );
}

export default DirhamIcon;
